<mat-sidenav-container [hidden]="!isLogged">
  <mat-sidenav #sidenav="matSidenav">
    <app-sidenav
      [user]="user"
      [isAdmin]="isAdmin"
      [version]="version"
      (userChanged)="user = $event"
    ></app-sidenav>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
